import React from "react";
import "./Partners.css";

export default function Partners() {
  return (
    <section className="partners">
      <h2>Access FCA‑Authorised Partner Services</h2>

      <p className="partners-note">
        This website does not provide advice or recommendations.  
        All services are accessed directly through FCA‑authorised providers.
      </p>

      <div className="partner-grid">
        <div className="partner-card">
          <h3>Breakdown Cover Partner</h3>
          <a href="/partners" className="partner-btn">Explore</a>
        </div>

        <div className="partner-card">
          <h3>Recovery Partner</h3>
          <a href="/partners" className="partner-btn">Explore</a>
        </div>

        <div className="partner-card">
          <h3>Transport Partner</h3>
          <a href="/partners" className="partner-btn">Explore</a>
        </div>
      </div>
    </section>
  );
}
